<template>
  <v-footer padless style="background: #303030">
    <v-container class="white--text px-4 py-4">
      <!-- Footer Header -->
      <div class="d-flex align-center">
        <span class="py-2 text-body-1 font-weight-medium">
          REPTTOWN V0.4.6 (BETA)
        </span>

        <v-btn
          class="ml-auto pl-2 font-weight-light"
          small
          plain
          :ripple="false"
          @click="$langs.switchLang()"
        >
          <v-icon small left>mdi-web</v-icon>
          {{ $langs.lang == "en" ? "ไทย" : "Eng" }}
        </v-btn>
      </div>

      <!-- Social Link -->
      <div class="btn-link">
        <v-btn
          class="font-weight-light white--text"
          href="https://www.facebook.com/repttown"
          target="_blank"
          small
          plain
          :ripple="false"
        >
          <v-icon x-small class="mr-1">fab fa-facebook-square</v-icon>
          Facebook </v-btn
        >&nbsp;
        <v-btn
          class="font-weight-light white--text"
          href="https://www.instagram.com/repttown"
          target="_blank"
          small
          plain
          :ripple="false"
        >
          <v-icon x-small class="mr-1">fab fa-instagram</v-icon>
          Instagram </v-btn
        >&nbsp;
        <v-btn
          class="font-weight-light white--text"
          href="https://twitter.com/marketpett_twt"
          target="_blank"
          small
          plain
          :ripple="false"
        >
          <v-icon x-small class="mr-1">fab fa-twitter</v-icon>
          Twitter
        </v-btn>
      </div>

      <!-- Link to page (in this site) -->
      <div class="d-flex align-center flex-wrap btn-link pb-1">
        <router-link to="/" class="mr-1 link text-caption grey--text text--lighten-2">{{ $langs.get("gen.home") }}</router-link>&nbsp;
        <router-link to="/aboutus" class="mr-1 link text-caption grey--text text--lighten-2">{{ $langs.get("gen.aboutus") }}</router-link>&nbsp;
        <span class="d-flex align-center">
          <router-link to="/term-of-use" class="mr-1 link text-caption grey--text text--lighten-2">{{ $langs.get("gen.terms") }}</router-link>&nbsp;
          <router-link to="/privacy-policy" class="mr-1 link text-caption grey--text text--lighten-2">{{ $langs.get("gen.privacy") }}</router-link>
        </span>
      </div>
    </v-container>
    <div
      class="text-center py-1"
      style="width: 100%; background: rgba(0, 0, 0, 0.4);"
    >
      <v-btn plain small class="white--text" :ripple="false" :href="newVersionUrl">
        ไปที่ New ReptTown
      </v-btn>
    </div>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      icons: ["mdi-facebook", "mdi-google", "mdi-instagram"],
    }
  },
  computed: {
    newVersionUrl() {
      // eg. /classic/product/1 -> /product/1
      return this.$route.path.replace("/classic", "")
    },
  },
}
</script>

<style scoped>
.btn-link > .v-btn {
  height: 28px;
  min-width: unset;
  padding-left: 0;
  padding-right: 0;
  margin-right: 8px;
}
</style>
